import React,{useState} from 'react'
import ChoiceSelect from './ChoiceSelect';
import Questions from './Questions';

const QuizCompo = () => {
  const [start,setStart] = useState(true)
  
  const handleStart = () =>{
    setStart(!start)  
 };
 const [optionValue, setOptionValue] = useState("Select");
    
    const handleSelect = (e) => {
        setOptionValue(e.target.value);
      };
  
   if (start){
     return (<div className='compoChoice'>
    <select name='category' className='category' onChange={handleSelect}>
        <option value="Select" >Select</option>
        <option value='sport' >Sport</option>
        <option value='maths'>Maths</option>
    </select>  <br/>
    <input type='button' className='startButton' value="Start" disabled={(optionValue==='Select')?true :false} onClick={handleStart}/>
   </div>);
 }else 
    return  (
    <div >
    <Questions name={optionValue}/>   
    </div> )
      
     
  
  
}

export default QuizCompo